import React from "react";

function PaymentModal({ isOpen, onClose, title, children }) {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ${
        isOpen ? "" : "hidden"
      }`}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg w-content relative">
        <h3 className="text-xl font-medium pt-3 pb-3">{title}</h3>
        <button
          type="button"
          className="absolute top-2 right-2 text-xl font-bold text-gray-600"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}

export default PaymentModal;
